<template lang="pug">
  transition(
    enter-active-class="animated fadeIn faster"
    leave-active-class="animated fadeOut faster"
    mode="in-out")
      .small-12.column.cart__minimum-value-error-container(v-if="showError")
        div
          svg.cart-product__warning-icon(width="16", height="16", viewBox="0 0 32 32")
            use(xlink:href="#alert_circle")
        p {{ errorText }}
</template>

<script>
export default {
  name: 'errorMessage',
  props: {
    showError: {
      type: Boolean,
      required: true,
      default: false,
    },
    errorText: {
      type: String,
      required: true,
      default: ''
    }
  },
};
</script>
